/* istanbul ignore file - need to fix flakey tests */

import { CategoryNode } from '@services/productInventory';
import { MRT_Row } from 'material-react-table';

export const getSelectedRows = (rows: MRT_Row<CategoryNode>[]) =>
  rows.filter((row) => {
    // Check if any of the selected rows is a parent of the current selected row being iterated
    const isChildOfSelectedRow = rows.some((selectedRow) =>
      selectedRow.original.children?.some((child) => child.PID === row.original.PID)
    );
    return !isChildOfSelectedRow;
  });
